import { Type } from '@sinclair/typebox';
import './formats.js';
/** RFC 5322 is not worth implementing; this rejects the mistakes users actually make. */
export const EmailSchema = Type.String({
    format: 'email',
    minLength: 3,
    maxLength: 254,
    pattern: '^[^@\\s]+@[^@\\s.]+(\\.[^@\\s.]+)+$',
});
/**
 * Password policy: length is the property that actually matters, so we require
 * real length rather than a composition rule that pushes people toward
 * "Passw0rd!". The upper bound exists because argon2 hashing time grows with
 * input and an unbounded password is a cheap denial-of-service.
 */
export const PasswordSchema = Type.String({ minLength: 12, maxLength: 256 });
export const UuidSchema = Type.String({
    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
});
export const IsoDateTimeSchema = Type.String({ format: 'date-time' });
export const NonEmptyStringSchema = Type.String({ minLength: 1 });
/** Six digits, kept as a string so a leading zero is never lost. */
export const TotpCodeSchema = Type.String({ pattern: '^[0-9]{6}$' });
/** Lower-cased hex, as produced by our client-side and server-side hashing. */
export const Sha256Schema = Type.String({ pattern: '^[0-9a-f]{64}$' });
export const LocaleSchema = Type.Union([Type.Literal('fr'), Type.Literal('en')]);
/**
 * Emails are compared case-insensitively and stored normalised, so that
 * `Nathan@Example.com` and `nathan@example.com` are one account rather than two.
 * Used both when creating a user and when looking one up for a group invite -
 * they must agree, or invitations would silently fail to find real accounts.
 */
export function normaliseEmail(email) {
    return email.trim().toLowerCase();
}
//# sourceMappingURL=primitives.js.map